import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import "vodal/common.css"
import '@/assets/css/swiper.css'
import '@/assets/css/icons/css/all.min.css'
import '@/assets/css/styles.css'
import '@/assets/css/extras.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
